import { useEffect, useState } from "react";
import { checkAdmin } from "../utils/jwtUtils";
import { useFeedback } from "../Contexts/FeedbackContext";
import { MAX_VALUES } from "../constants/NoteValues";
import { saveNote } from "../services/noteService";
import { ERROR_UPDATE, SUCCESS_UPDATE } from "../constants/feedbacks";

export function useTabs(initialNotes, studentId) {
  const isAdmin = checkAdmin();
  const [noteStates, setNoteStates] = useState(initialNotes);
  const [noteTotal, setNoteTotal] = useState(0);
  const { showFeedback } = useFeedback();

  useEffect(() => {
    setNoteStates(initialNotes);
  }, [initialNotes, studentId]);

  useEffect(() => {
    setNoteTotal(
      noteStates.reduce((acc, note) => acc + (parseFloat(note.value) || 0), 0)
    );
  }, [noteStates]);

  const handleNoteChange = (module, newValue, index) => {
    const maxValue = MAX_VALUES[module];
    if (+newValue > maxValue) return alert(`Max: ${maxValue}`);
    setNoteStates((prev) =>
      prev.map((n, i) => (i === index ? { ...n, value: newValue } : n))
    );
  };

  const handleSubmit = async () => {
    try {
      const updates = noteStates
        .map((note) =>
          !note.exist && note.value
            ? saveNote(note, studentId, "post")
            : note.exist && note.value && isAdmin
            ? saveNote(note, studentId, "patch")
            : null
        )
        .filter(Boolean);

      await Promise.all(updates);
      setNoteStates((s) => s.map((n) => ({ ...n, exist: true })));
      showFeedback(SUCCESS_UPDATE, true);
    } catch (err) {
      console.error("Error:", err.message);
      showFeedback(ERROR_UPDATE, false);
    }
  };

  return {
    noteStates,
    noteTotal,
    isAdmin,
    handleNoteChange,
    handleSubmit,
  };
}
